<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import simplebar from "simplebar-vue";
import { authMethods } from "@/state/helpers";

import { menuItems } from "./menu";

/**
 * Sidebar component
 */
export default {
  data() {
    return {
      menuItems: menuItems,
      notifications: [],
      unread_notifications_count: 0,
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  components: {
    simplebar,
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    this._activateMenuDropdown();
    this.hideMenu();

    this.$router.afterEach(() => {
      this._activateMenuDropdown();
    });
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              break;
            case "light":
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...authMethods,
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logoutUser() {
      this.logOut();
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    hideMenu() {
      //  if(this.isManager()){
      //    this.menuItems=this.menuItems.filter((item)=>(item.id!=5 && item.id!=6))
      //  }
    },
    /**
     * remove active and mm-active class
     */
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        els[0].classList.remove(className);
      }
    },
    _activateMenuDropdown() {
      this._removeAllClass("mm-active");
      this._removeAllClass("mm-show");

      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];

      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    onRoutechange() {
      setTimeout(() => {
        if (document.getElementsByClassName("mm-active").length > 0) {
          const currentPosition = document.getElementsByClassName(
            "mm-active"
          )[0].offsetTop;
          if (currentPosition > 500)
            this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
        }
      }, 300);
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu">

    <div class="navbar-brand-box kk d-none d-lg-block">
      <router-link to="/" class="logo logo-dark">
        <span class="logo-sm">
          <img src="@/assets/images/logo-sm.png" alt height="22" />
        </span>
        <span class="logo-lg">
          <img src="@/assets/images/logo.png" alt class="w-100 img-fluid mx-auto d-block mt-3" />
        </span>
      </router-link>

      <router-link to="/" class="logo logo-light">
        <span class="logo-sm">
          <img src="@/assets/images/dashboard-logo.png" alt height="22" />
        </span>
        <span class="logo-lg">
          <img src="@/assets/images/dashboard-logo.png" alt class="w-50" />
        </span>
      </router-link>
    </div>

        <div class="navbar-brand-box kk d-block d-lg-none">
      <router-link to="/" class="logo logo-dark">
        <span>
          <img src="@/assets/images/logo.png" alt class="w-100 img-fluid mx-auto d-block mt-3" />
        </span>
      </router-link>
      <router-link to="/" class="logo logo-light">
        <span>
          <img src="@/assets/images/dashboard-logo.png" alt class="w-50" />
        </span>
      </router-link>
    </div>

    <button
      type="button"
      @click="toggleMenu"
      class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
    >
      <i class="fa fa-fw fa-bars"></i>
    </button>

    <simplebar class="sidebar-menu-scroll" ref="currentMenu">
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled mx-2" id="side-menu">

          <template v-for="item in menuItems">
            <!-- TITLE -->
            <li class="menu-title" v-if="item.isTitle" :key="'title-' + item.id">
              {{ $t(item.label) }}
            </li>

            <!-- PARENT -->
            <li v-if="!item.isTitle && !item.isLayout" :key="'item-' + item.id">

              <!-- FIRST LEVEL PARENT -->
              <a
                v-if="hasItems(item)"
                href="javascript:void(0);"
                class="is-parent has-arrow rounded-pill"
              >
                <i v-if="item.icon" :class="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
              </a>

              <!-- SINGLE LINK -->
              <router-link
                v-if="!hasItems(item)"
                :to="item.link"
                class="side-nav-link-ref rounded-pill"
              >
                <i v-if="item.icon" :class="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
              </router-link>

              <!-- FIRST LEVEL SUBMENU -->
              <ul
                v-if="hasItems(item)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="subitem in item.subItems"
                  :key="'sub-' + subitem.id"
                >

                  <!-- SECOND LEVEL PARENT (Customer Listings) -->
                  <a
                    v-if="hasItems(subitem)"
                    href="javascript:void(0);"
                    class="is-parent has-arrow side-nav-link-a-ref"
                  >
                    {{ $t(subitem.label) }}
                  </a>

                  <!-- SECOND LEVEL LINK -->
                  <router-link
                    v-if="!hasItems(subitem)"
                    :to="subitem.link"
                    class="side-nav-link-ref"
                  >
                    {{ $t(subitem.label) }}
                  </router-link>

                  <!-- SECOND LEVEL SUBMENU -->
                  <ul
                    v-if="hasItems(subitem)"
                    class="sub-menu mm-collapse"
                    aria-expanded="false"
                  >
                    <li
                      v-for="subSubitem in subitem.subItems"
                      :key="'subsub-' + subSubitem.id"
                    >
                      <router-link
                        :to="subSubitem.link"
                        class="side-nav-link-ref"
                      >
                        {{ $t(subSubitem.label) }}
                      </router-link>
                    </li>
                  </ul>

                </li>
              </ul>

            </li>
          </template>
          <li>
                <div class="mobile-sidebar-actions d-lg-none border-top align-self-end mx-3">
      <div class="d-flex justify-content-around align-items-center">
        <button
          type="button"
          class="btn btn-link p-2"
          @click="initFullScreen"
        >
          <i class="uil-minus-path" style="font-size: 24px;"></i>
        </button>
        <b-dropdown
          variant="link"
          class="p-0"
          toggle-class="p-2 position-relative"
          dropup
          menu-class="dropdown-menu-lg"
        >
          <template v-slot:button-content>
            <img src="@/assets/images/navNotification.svg" width="24" height="24">
            <span
              class="
                badge
                border border-warning border-white
                f-12
                p-1
                primaryColorBg
                rounded-circle
                position-absolute
                top-0
                end-0
              "
              style="transform: translate(25%, -25%);"
              >{{ unread_notifications_count > 99 ? '99+' : unread_notifications_count }}</span
            >
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h5 class="m-0 font-size-16">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h5>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px" data-simplebar>
            <div v-for="(notification, index) in notifications" :key="index">
              <a
                class="text-reset notification-item"
                href="javascript:void(0)"
                @click="readNotification(notification)"
              >
                <div
                  class="media"
                  :class="{ 'bg-body': notification.read_at == null }"
                >
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">
                      {{ notification.data.subject }}
                    </h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">
                        {{ notification.data.message }}
                      </p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ formattedTime(notification.created_at) }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </simplebar>
          <div class="p-2 border-top">
            <div class="d-grid text-center">
            </div>
          </div>
        </b-dropdown>
        <b-dropdown
          variant="link"
          class="p-0"
          toggle-class="p-2"
          dropup
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img src="@/assets/images/Union.png" width="24" height="24">
          </template>

          <a class="dropdown-item" style="cursor: pointer" @click="logoutUser">
            <i
              class="
                uil uil-sign-out-alt
                font-size-18
                align-middle
                me-1
                text-muted
              "
            ></i>
            <span class="align-middle">{{
              $t("navbar.dropdown.marcus.list.logout")
            }}</span>
          </a>
        </b-dropdown>
      </div>
    </div>
          </li>
        </ul>
      </div>
    </simplebar>
  </div>
  <!-- Left Sidebar End -->
</template>

<style scoped>
/* .mobile-sidebar-actions {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  background: inherit;
}

.mobile-sidebar-actions .btn-link {
  color: inherit;
  text-decoration: none;
} */

@media (max-width: 991.98px) {
  .sidebar-menu-scroll {
    padding-bottom: 80px;
  }
}
</style>